/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

export interface AdvertiserModel extends SignalAdminResourceModel {
  [key: string]: any;
}

export interface AdvertiserInvite {
  id: string;
  name?: string;
  email?: string;
  subject?: string;
  idOfPoliticalEntity?: string;
  expiry?: string;
}

@Injectable({providedIn: 'root'})
export class AdvertiserApiService extends SignalAdminResourceApiBase<AdvertiserModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'advertisers');
  }

  listOptions(params: Record<string, any> = {}): Observable<SignalAdminResourcePage<AdvertiserModel>> {
    return this.client.request<SignalAdminResourcePage<AdvertiserModel>>({
      method: 'GET',
      url: this.resourceUri('advertisers'),
      params
    });
  }

  bulkSave(models: Partial<AdvertiserModel>[]): Observable<void> {
    return this.saveMany(models);
  }

  emailInvite(invite: AdvertiserInvite): Observable<void> {
    return this.invite('emailinvite', invite);
  }

  emailPoliticalEntityInvite(invite: AdvertiserInvite): Observable<void> {
    return this.invite('emailinvitepoliticalentity', invite);
  }

  currentPoliticalEntityInvite(id: string): Observable<any> {
    return this.client.request<any>({
      method: 'GET',
      url: this.resourceUri(['advertisers', 'emailinvitepoliticalentity', id]),
      params: {}
    });
  }

  expirePoliticalEntityInvite(invite: AdvertiserInvite): Observable<void> {
    return this.invite('emailinvitepoliticalentity', invite);
  }

  private invite(path: string, invite: AdvertiserInvite): Observable<void> {
    return this.client.request<void>({
      method: 'POST',
      url: this.resourceUri(['advertisers', path, invite.id]),
      params: {},
      body: invite
    });
  }
}
